import styled from 'styled-components';

const DashboardTableCols = styled.div<{ $minimal: boolean }>`
  display: flex;
  > div {
    padding: 5px 1px;
    flex-grow: 0;
    flex-shrink: 0;
    width: 0;
  }
  > div:nth-child(1) {
    padding-left: 12px;
    text-align: left;
    flex: 3;
  }
  ${({ $minimal }) =>
    $minimal
      ? `
    > div:nth-child(2) {
      text-align: right;
      flex: 2.2;
      padding-right: 6px;
    }
  `
      : `
    > div:nth-child(2) {
      text-align: right;
      flex: 2.6;
    }
    > div:nth-child(3) {
      text-align: right;
      flex: 2.2;
      padding-right: 6px;
    }
    `}
`;

/** Shared table row for Dashboard components Trades component */
export const DashboardTableRow = styled(DashboardTableCols)`
  align-items: center;
  > div {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${({ $minimal }) =>
    $minimal
      ? `
    > div:nth-child(2) {
      padding-right: 5px;
    }
  `
      : `
    > div:nth-child(2) {
      padding-right: 5px;
    }
    > div:nth-child(3) {
      padding-right: 5px;
    }
  `}
`;

/** Shared table header for Dashboard components: Orderbook and Trades */
export const DashboardTableHeader = styled(DashboardTableCols)`
  color: var(--gray4);
  text-transform: uppercase;
  font-size: var(--smallest);
  text-align: left;
`;
